import React, { useMemo } from "react";

import { EnvironmentListBar } from "../";
import { EnvironmentTreeData } from "../utils";

import * as S from "./Node.styles";

const hasChildWithState = (children, showEnvs) => {
  return children.some(
    child =>
      (child.status !== "inactive" && showEnvs.active) ||
      (child.status === "inactive" && showEnvs.inactive) ||
      hasChildWithState(child.children, showEnvs)
  );
};

type NodeProps = {
  node: EnvironmentTreeData;
  organizationId: string;
  showEnvs: { active: boolean; inactive: boolean };
  titleFilter: string;
  visibleNodes?: string[];
  isBigScreen?: boolean;
};

const Node = ({
  node,
  organizationId,
  showEnvs,
  titleFilter,
  visibleNodes,
  isBigScreen
}: NodeProps) => {
  const hasChildInState = useMemo(() => {
    if (
      (node.status !== "inactive" && !showEnvs.active) ||
      (node.status === "inactive" && !showEnvs.inactive)
    ) {
      return hasChildWithState(node.children, showEnvs);
    }

    return false;
  }, [node, showEnvs]);

  if (visibleNodes && !visibleNodes.includes(node.environmentId)) return null;

  if (
    (!node.children.length || !hasChildInState) &&
    ((node.status !== "inactive" && !showEnvs.active) ||
      (node.status === "inactive" && !showEnvs.inactive))
  ) {
    return null;
  }
  return (
    <S.NodeLayout
      depth={node.depth}
      hasChildren={node.children.length > 0}
      isRoot={node.isRoot}
      status={node.status}
    >
      <EnvironmentListBar
        node={node}
        titleFilter={titleFilter}
        isBigScreen={isBigScreen}
      />

      <S.Children>
        {node.children.map(child => (
          <Node
            isBigScreen={isBigScreen}
            key={`node-${child.environmentId}`}
            node={child}
            organizationId={organizationId}
            showEnvs={showEnvs}
            titleFilter={titleFilter}
            visibleNodes={visibleNodes}
          />
        ))}
      </S.Children>
    </S.NodeLayout>
  );
};

export default Node;
